import React, { useState, useEffect, useRef } from 'react';
import { useSelector, useDispatch } from 'react-redux';

import LevelDropdown from './levelDropdown.js';
import CategoryDropdown from './categoryDropdown.js';
import ProtocolDropdown from './protocolDropdown.js';
import AnnexesDropdown from './annexesDropdown.js';
import StagesDropdown from './stagesDropdown.js';
import RefreshButton from './refreshButton.js';
import InfoTooltip from '../infoTooltip/infoTooltip.js';

import Slide from '@material-ui/core/Slide';
import Divider from '@material-ui/core/Divider';
import { _ } from '../../functions/translator.js';
import CustomCardTypesButton from './customCardTypesButton.js';
import { FilterActions } from '../../constants/constants.js';
import { filterChange } from '../../actions/index';

function FiltersSet() {
  const dispatch = useDispatch();
  const [mobileDropdownOpen, setMobileDropdownOpen] = useState(false);
  const dropdownRef = useRef(null);

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setMobileDropdownOpen(false);
      }
    };

    if (mobileDropdownOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [mobileDropdownOpen]);

  const {
    itemsSwitch,
    popUpMenu,
    popUpMessage,
    customCards,
    userData,
    customcardTypes,
    whatsappObservationsPopup,
  } = useSelector((state) => ({
    itemsSwitch: state.switches.items,
    popUpMenu: state.popUpMenu,
    popUpMessage: state.popUpMessage,
    customCards: state.projectData.customcards,
    userData: state.userData,
    customcardTypes: state.customcardTypes,
    whatsappObservationsPopup: state.whatsappObservations.popup,
  }));
  let userActiveModules = userData.attributes.active_modules
    ? userData.attributes.active_modules.split(', ')
    : [];
  const [activeCustomcardTypes, setActiveCustomcardTypes] = useState(userActiveModules.length > 0 ? [userActiveModules[0]] : []);

  const handleCustomcardTypeChange = (customcardType) => {
    if (activeCustomcardTypes.includes(customcardType)) {
      return;
    }

    const newActiveTypes = [customcardType];
    dispatch(filterChange(FilterActions.CUSTOMCARD_TYPES, newActiveTypes));
    setActiveCustomcardTypes(newActiveTypes);

    const selectedCustomcardIds = Object.entries(customCards)
      .filter(([_, value]) => value.attributes.type_ === customcardType)
      .map(([key]) => key);

    if (selectedCustomcardIds.length === 0) {
      dispatch(filterChange(FilterActions.CUSTOMCARD, null));
    } else {
      dispatch(filterChange(FilterActions.CUSTOMCARD, selectedCustomcardIds));
    }
  };

  const filterWidth = '18%';

  return (
    <div>
      <Slide in={!popUpMessage.show && !popUpMenu.show && !whatsappObservationsPopup.show} direction="down">
        <div className={itemsSwitch ? 'filters-card-layout filters-right card-color' : 'filters-card-layout card-color'}>
          <div className="filters-container flex-fill">
            <div style={{ width: filterWidth }}>
              <StagesDropdown />
            </div>
            <div style={{ width: filterWidth }}>
              <LevelDropdown />
            </div>
            <div style={{ width: filterWidth }}>
              <CategoryDropdown />
            </div>
            <div style={{ width: filterWidth }}>
              <ProtocolDropdown />
            </div>
            <div style={{ width: filterWidth }}>
              <AnnexesDropdown />
            </div>
            <InfoTooltip message={'filters message'} />
            <div>
              <Divider className="divider mr-4" variant="middle" orientation="vertical" />
            </div>
          </div>
          <div className='d-flex flex-row justify-content-between'>
            <RefreshButton />
            {/* Mobile dropdown version */}
            <div className="customcard-types-mobile-dropdown" ref={dropdownRef}>
              <button 
                className="mobile-dropdown-trigger"
                onClick={() => setMobileDropdownOpen(!mobileDropdownOpen)}
              >
                <span className="mobile-dropdown-text">
                  Módulos
                </span>
                <i className={`mdi mdi-chevron-${mobileDropdownOpen ? 'up' : 'down'} mobile-dropdown-icon`}></i>
              </button>
              
              {mobileDropdownOpen && (
                <div className="mobile-dropdown-content">
                  {customcardTypes
                    .filter(({ title }) => userActiveModules.includes(title))
                    .map(({ title, icon }) => (
                      <CustomCardTypesButton
                        key={title}
                        title={title}
                        icon={icon}
                        selected={activeCustomcardTypes.includes(title)}
                        onClick={() => handleCustomcardTypeChange(title)}
                      />
                    ))}
                </div>
              )}
            </div>
          </div>
        </div>
      </Slide>

      {(!popUpMessage.show && !popUpMenu.show && !whatsappObservationsPopup.show) && (
        <>
          {/* Desktop version */}
          <div className={itemsSwitch ? 'customcard-types-buttons-layout filters-right' : 'customcard-types-buttons-layout'}>
            {customcardTypes
              .filter(({ title }) => userActiveModules.includes(title))
              .map(({ title, icon }) => (
                <CustomCardTypesButton
                  key={title}
                  title={title}
                  icon={icon}
                  selected={activeCustomcardTypes.includes(title)}
                  onClick={() => handleCustomcardTypeChange(title)}
                />
              ))}
          </div>
        </>
      )}
    </div>
  );
}

export default FiltersSet;